// Chakra imports
import {
  Box,
  Portal,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import Footer from 'components/footer/FooterAdmin';
// Layout components
import Navbar from 'components/navbar/NavbarAdmin';
import Sidebar from 'components/sidebar/Sidebar';
import { SidebarContext } from 'contexts/SidebarContext';
import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import useRoutes from 'routes';
import NotFound from 'views/admin/404/404';
import AppointmentDetailPage from 'views/admin/Appointment Management/Appointment Details/AppointmentDetails';
import CreateAppointment from 'views/admin/Appointment Management/Create Appointment/CreateAppointment';
import AddAsset from 'views/admin/asset-management/AddAsset';
import AssetDetail from 'views/admin/asset-management/AssetDetail';
import EditAsset from 'views/admin/asset-management/EditAsset';
import CalibrationDetail from 'views/admin/Calibration/CalibrationDetail';
import NewRecord from 'views/admin/Calibration/NewRecord';
import CertificateDetailPage from 'views/admin/Certificate/Certificate Details/CertificateDetails';
import CertificateList from 'views/admin/Certificate/Certificate List/CertificateList';
import CertificateUpload from 'views/admin/Certificate/Certificate Upload/CertificateUpload';
import AddEmail from 'views/admin/Email Template/AddEmail';
import EditEmailForm from 'views/admin/Email Template/EditEmail';
import AddNotificationForm from 'views/admin/notification/AddNotification';
import NotificationDetail from 'views/admin/notification/NotificationDetail';
import AddOrganizationForm from 'views/admin/Organization/AddOrg';
import OrgDetail from 'views/admin/Organization/OrgDetail';
import AddUser from 'views/admin/UserList/AddUser';
import Unauthorized from 'views/admin/unauthorized/unauthoriz';
import Settings from 'views/admin/userprofile';
import UserProfile from 'views/admin/userprofile/components/UserProfile';

import AddVendorForm from 'views/admin/vendors/AddVendorForm';
import VendorAddProduct from 'views/admin/vendors/VendorAddProduct';
import VendorDetail from 'views/admin/vendors/VendorDetail';
import VendorProduct from 'views/admin/vendors/VendorProducts';
import WithAuthProtection from 'views/auth/withauthprotection/withauthprotection';
import AddContractorForm from 'views/admin/Organization/Component/AddContractor';
import LocationAdmin from 'views/admin/dashboards/locAdminDashboard';

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const routes = useRoutes()
  const { ...rest } = props;
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [mini, setMini] = useState(false);
  const [hovered, setHovered] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };
  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes: RoutesType[]): any => {
    return routes.map((route: RoutesType, key: number) => {
      if (route.layout === '/admin') {
        return (
          <Route path={`${route.path}`} element={route.component} key={key} />
        );
      }
      if (route.collapse) {
        return getRoutes(route.items);
      } else {
        return null;
      }
    });
  };
  document.documentElement.dir = 'ltr';
  const { onOpen } = useDisclosure();
  const bg = useColorModeValue('background.100', 'background.900');
  return (
    <Box bg={bg} h="100vh" w="100vw">
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar
          hovered={hovered}
          setHovered={setHovered}
          mini={mini}
          routes={routes}
          display="none"
          {...rest}
        />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={
            mini === false
              ? { base: '100%', xl: 'calc( 100% - 290px )' }
              : mini === true && hovered === true
                ? { base: '100%', xl: 'calc( 100% - 290px )' }
                : { base: '100%', xl: 'calc( 100% - 120px )' }
          }
          maxWidth={
            mini === false
              ? { base: '100%', xl: 'calc( 100% - 290px )' }
              : mini === true && hovered === true
                ? { base: '100%', xl: 'calc( 100% - 290px )' }
                : { base: '100%', xl: 'calc( 100% - 120px )' }
          }
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                hovered={hovered}
                setMini={setMini}
                mini={mini}
                onOpen={onOpen}
                logoText={'CaliMaster'}
                brandText={getActiveRoute(routes)}
                secondary={getActiveNavbar(routes)}
                theme={props.theme}
                setTheme={props.setTheme}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: '20px', md: '30px' }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Routes>
                {getRoutes(routes)}
                <Route path='/vendors/AddVendor' element={<WithAuthProtection allowedRoles={["Admin", "Vendors", "DeptUser", "OrgAdmin", "LeasedOrg"]}><AddVendorForm /></WithAuthProtection>} />
                <Route path='/vendors/:id' element={<WithAuthProtection allowedRoles={["Admin", "Vendor", "DeptUser", "OrgAdmin", "LocationAdmin", "LeasedOrg"]}> <VendorDetail /></WithAuthProtection>} />
                <Route path='/vendors/VendorProduct' element={<WithAuthProtection allowedRoles={["Admin", "DeputUser", "OrgAdmin", "Vendor", "LocationAdmin", "LeasedOrg"]}> <VendorProduct /></WithAuthProtection>} />
                <Route path='/vendors/VendorAddProduct' element={<WithAuthProtection allowedRoles={["Admin", "DeptUset", "OrgAdmin", "Vendor", "LocationAdmin", "LeasedOrg"]}> <VendorAddProduct /></WithAuthProtection>} />
                <Route path='/Calibration/newRecord' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "LocationAdmin", "LeasedOrg"]}> <NewRecord /></WithAuthProtection>} />
                <Route path='/Calibration/:calibrationId' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}> <CalibrationDetail /></WithAuthProtection>} />
                <Route path='/asset-management/:assetId' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}> <AssetDetail /></WithAuthProtection>} />
                <Route path='/asset-management/AddAsset' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "LocationAdmin", "LeasedOrg"]}> <AddAsset /></WithAuthProtection>} />
                <Route path='/asset-management/EditAsset' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "LeasedOrg"]}> <EditAsset /> </WithAuthProtection>} />
                <Route path='/organizations/OrgDetail' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}> <OrgDetail /></WithAuthProtection>} />
                <Route path='/organizations/AddOrg' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "LeasedOrg"]}>  <AddOrganizationForm /></WithAuthProtection>} />
                <Route path='/CertificateList' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LeasedOrg"]}> <CertificateList /></WithAuthProtection>} />
                <Route path='/CertificateDetails' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LeasedOrg"]}><CertificateDetailPage /></WithAuthProtection>} />
                <Route path='/CertificateListUpload' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LeasedOrg"]}> <CertificateUpload /></WithAuthProtection>} />
                <Route path='/notification/NotificationDetail' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}><NotificationDetail /></WithAuthProtection>} />
                <Route path='/notification/AddNotification' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}><AddNotificationForm /></WithAuthProtection>} />
                <Route path='/CreateAppointment' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser"]}><CreateAppointment /></WithAuthProtection>} />
                <Route path='/AppointmentDetailPage' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}><AppointmentDetailPage /></WithAuthProtection>} />
                <Route path='/Template/AddTemplate' element={<WithAuthProtection allowedRoles={["Admin"]}> <AddEmail /></WithAuthProtection>} />
                <Route path='/Template/EditTemplate' element={<WithAuthProtection allowedRoles={["Admin"]}> <EditEmailForm /></WithAuthProtection>} />
                <Route path='/Userprofile' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}><UserProfile /></WithAuthProtection>} />
                <Route path='/profile/adduser' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "LocationAdmin"]}> <AddUser /></WithAuthProtection>} />
                <Route path='/setting' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor"]}><Settings /></WithAuthProtection>} />
                <Route path='/organizations/Addcontractor' element={<WithAuthProtection allowedRoles={["OrgAdmin", "Admin", "LocationAdmin"]}> <AddContractorForm /> </WithAuthProtection>} />
                <Route path='/Unauthorized' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}>element={<Unauthorized />}</WithAuthProtection>} />
                <Route path='/*' element={<WithAuthProtection allowedRoles={["Admin", "OrgAdmin", "DeptUser", "Vendor", "LocationAdmin", "LeasedOrg"]}><NotFound /></WithAuthProtection>} />
                <Route
                  path="/"
                  element={<Navigate to="/auth/sign-in" replace />}
                />
              </Routes>
            </Box>
          ) : null}
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
